import { render, staticRenderFns } from "./PbLabel.vue?vue&type=template&id=3185bd33&"
import script from "./PbLabel.vue?vue&type=script&lang=js&"
export * from "./PbLabel.vue?vue&type=script&lang=js&"
import style0 from "./PbLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports